'use client'

import { Button, ConfigProvider, Result } from 'antd'
import { ThemeContext } from 'context/theme.context'
import Link from 'next/link'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { setCompanyId } from 'store/company'
import styled from 'styled-components'
import { BodyBlock } from './body.block'
import { Toolbar } from './toolbar'

const Hero = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: calc(100vh - 10px);
  padding-top: 60px;

  .ant-result-extra {
    justify-content: center;
    display: flex;
  }

  button {
    margin-bottom: 20px;
    background: #eb6435;
    border-radius: 6px;
    color: #fff;
    display: flex;
    align-items: center;
  }
`

interface OwnProps {
  code?: 'success' | 'error' | 'info' | 'warning' | 404 | 403 | 500
  title?: string
  text?: string
  gotoHome?: boolean
  gotoApp?: boolean
}

type Props = OwnProps

export const ErrorPage: React.FC<Props> = (props) => {
  const { toolbarTheme: theme } = useContext(ThemeContext)
  const { t, i18n } = useTranslation()
  const dispatch = (a) => {} // useAppDispatch()

  return (
    <>
      <ConfigProvider theme={theme}>
        <Toolbar/>
      </ConfigProvider>
      <BodyBlock>
        <Hero>
          <Result
            status={props.code || 'info'}
            title={props.title}
            subTitle={props.text}
            extra={[
              props.gotoHome && (
                <Button href={'/'} key={'home'}>{t('error-home-btn', 'Go Home')}</Button>
              ),
              props.gotoApp && (
                <Link href={`/${i18n.language}/app`} key={'app'} passHref>
                  <Button>{t('error-home-btn', 'Go Home')}</Button>
                </Link>
              ),
              <Button key={'reset'} onClick={() => dispatch(setCompanyId(null))}>
                {t('error-clear-company', 'Back to Company Chooser')}
              </Button>,
            ]}
          />
        </Hero>
      </BodyBlock>
    </>
  )
}
